import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { TfiEmail } from "react-icons/tfi";
import { FaLocationDot } from "react-icons/fa6";
import Trend from "../assets/images/trend.png";
import User from "../assets/images/user.png";
import Graph from "../assets/images/graph.png";
import Care from "../assets/images/care.png";

export const NavTabs = [
    {
        nav: "Home",
        path: "home"
    },
    {
        nav: "About Us",
        path: "about"
    },
    {
        nav: "Services",
        path: "services"
    },
    {
        nav: "Contact Us",
        path: "contact"
    },
];

export const AuditData = [
    {
        text: "Lender Compliance Audits",
        subText: {
            text: "Establish a complaint handling process"
        }
    },
    {
        text: "Regulatory Compliance GAP Review and Assessment"
    },
    {
        text: "Development of Standard Operating Procedures"
    },
    {
        text: `Testing Program to Ensure Lenders Operate within Regulatory Guidelines`
    },
    {
        text: "Identification of Barriers to Compliance"
    },
    {
        text: `Advise on Best Practices and Current Areas of Scrutiny of Regulators`
    },
    {
        text: "Remote or On-site Audits"
    },
    {
        text: "Audit Lenders and High-risk Vendors"
    },
];

export const AccordianData = [
    {
        title: "How does the fractional service model work?",
        data: "Our fractional service model allows clients to access experienced regulatory professionals for as few as 20 hours per month, offering flexible and cost-effective solutions."
    },
    {
        title: "What industries does Tribal Reg specialize in?",
        data: ""
    },
    {
        title: "What is the experience level of your team?",
        data: ""
    },
    {
        title: "Are your services available remotely?",
        data: ""
    },
    {
        title: "How can Tribal Reg help with compliance?",
        data: ""
    },
    {
        title: "How can Tribal Reg help with compliance?",
        data: ""
    },
    {
        title: "Can Tribal Reg assist with board and committee needs?",
        data: ""
    },
]

export const ServiceCardData = [
    {
        image: Trend,
        title: "Quality Regulatory Compliance...",
        content: `A Tribal Reg Compliance Professional is a key business partner for each tribal regulatory body engaged in 
        e-commerce.`,
        fullContent: `
            <p>Tribal Regulatory Services’ compliance professionals play an indispensable role as a strategic partner for each tribal regulatory body involved in e-commerce. Their expertise ensures that regulatory frameworks align with both tribal sovereignty and the complex requirements of the e-commerce landscape.</p>
    
            <p><b>Key functions of these professionals include:</b></p>
    
            <ul>
                <li><b>1. Developing Robust Compliance Programs:</b> Creating tailored policies, procedures, and oversight mechanisms that uphold regulatory standards while fostering sustainable growth for tribal enterprises.</li>
                <li><b>2. Navigating Regulatory Environments:</b> Acting as a bridge between tribal regulations and external regulatory bodies, ensuring seamless compliance with applicable laws such as data privacy, cybersecurity, and consumer protection.</li>
                <li><b>3. Mitigating Risks:</b> Proactively identifying compliance vulnerabilities and implementing measures to prevent risks, safeguarding the reputation and financial stability of the tribal organizations.</li>
                <li><b>4. Empowering Stakeholders:</b> Educating and collaborating with tribal leaders, staff, and partners to foster a culture of compliance and awareness, critical for long-term success.</li>
            </ul>
    
            <p>Through our commitment to excellence, Tribal Regulatory Services professionals help tribal regulatory bodies maintain integrity, build trust with stakeholders, and harness the vast potential of e-commerce to advance tribal economic development.</p>
        `
    },
    
    {
        image: User,
        title: `Board/Committee Contribution`,
        content: `Tribal Reg can perform a number of functions for the board that regulates your business. This would include`,
        fullContent: `
          <p>Tribal Regulatory Services’ compliance professionals play a vital role in assisting boards or committees by ensuring regulatory alignment, operational integrity, and strategic oversight. Their contributions include:</p>
          
          <ol>
            <li><b>Risk Assessment and Management:</b>
              <ul>
                <li>Conducting regular evaluations to identify regulatory risks, gaps, or vulnerabilities.</li>
                <li>Presenting actionable solutions to the board to mitigate potential compliance risks.</li>
              </ul>
            </li>

            <li><b>Monitoring and Reporting:</b>
              <ul>
                <li>Providing ongoing monitoring of compliance adherence across all levels of the business.</li>
                <li>Preparing detailed reports for the board that highlight successes, challenges, and compliance trends.</li>
              </ul>
            </li>

            <li><b>Regulatory Advocacy:</b>
              <ul>
                <li>Acting as a liaison between the board and external regulatory bodies, ensuring transparent communication and negotiation.</li>
                <li>Advocating for tribal interests in policy discussions and legislative changes affecting e-commerce and related industries.</li>
              </ul>
            </li>

            <li><b>Strategic Guidance:</b>
              <ul>
                <li>Offering insights to the board on emerging regulatory trends and opportunities for innovation.</li>
                <li>Supporting decision-making by aligning business strategies with regulatory best practices.</li>
              </ul>
            </li>

            <li><b>Training and Education:</b>
              <ul>
                <li>Educating board members and staff on regulatory requirements, fostering a culture of compliance and accountability.</li>
                <li>Facilitating workshops or sessions to keep the board informed of evolving laws and policies.</li>
              </ul>
            </li>
          </ol>
          
          <p><b>A Collaborative Impact</b></p>
          <p>By integrating regulatory expertise into board functions, Tribal Regulatory Services’ compliance professionals ensure the board operates with confidence, credibility, and foresight. This collaboration enhances the ability of the business to thrive in competitive markets while honoring tribal values and sovereignty.</p>
        `
    },
    {
        image: Graph,
        title: "Program Implementation",
        content: `Tribalal Regulatory Services can assist in implementation of various business including consumer and commercial lending.`,
        fullContent: `
          <p>Tribal Regulatory Services’ compliance professionals play a pivotal role in the successful implementation of business programs by ensuring regulatory alignment and operational efficiency. Their expertise in consumer and commercial lending programs can make a tangible impact.</p>
          
          <h5><b>Consumer and Commercial Lending Implementation</b></h5>
          
          <ol>
            <li><b>Regulatory Analysis:</b>
              <ul>
                <li>Ensuring lending programs align with tribal and federal laws, including fair lending practices, credit disclosures, and anti-discrimination regulations.</li>
                <li>Conducting gap analyses to identify areas requiring compliance improvements before program rollout.</li>
              </ul>
            </li>

            <li><b>Policy Development and Standardization:</b>
              <ul>
                <li>Creating clear, compliant policies for lending operations, including loan approvals, interest rates, repayment terms, and collections.</li>
                <li>Standardizing documentation and contract formats to protect tribal businesses and borrowers alike.</li>
              </ul>
            </li>

            <li><b>Risk Mitigation:</b>
              <ul>
                <li>Developing robust mechanisms to assess and manage credit risk while maintaining compliance with regulatory standards.</li>
                <li>Implementing fraud prevention strategies to safeguard both tribal enterprises and consumer interests.</li>
              </ul>
            </li>

            <li><b>Training and Capacity Building:</b>
              <ul>
                <li>Providing education and training for staff involved in lending operations, ensuring they understand regulatory requirements and compliance responsibilities.</li>
                <li>Empowering tribal regulatory bodies to oversee and adapt lending programs as market dynamics evolve.</li>
              </ul>
            </li>

            <li><b>Stakeholder Engagement:</b>
              <ul>
                <li>Collaborating with tribal leaders, financial institutions, and regulators to design lending programs that meet the needs of the community while maintaining compliance.</li>
                <li>Building partnerships to access funding opportunities or enhance program scalability.</li>
              </ul>
            </li>
          </ol>
        `
    },
    {
        image: Care,
        title: "Regulatory Training & Support",
        content: `This service can focus on providing education and resources to ensure clients understand and adhere to regulatory requirements,`,
        fullContent: `
          <p>This vital service equips clients with the knowledge, skills, and resources they need to confidently navigate regulatory requirements, empowering them to maintain compliance and reduce risk.</p>

          <h5><b>Key Focus Areas:</b></h5>

          <ol>
            <li><b>Education & Awareness:</b>
              <ul>
                <li>Designing targeted training programs that address specific regulatory topics, including compliance standards, best practices, and emerging regulations.</li>
                <li>Delivering workshops, webinars, or in-person sessions tailored to the needs of tribal enterprises and other stakeholders.</li>
              </ul>
            </li>

            <li><b>Resource Development:</b>
              <ul>
                <li>Providing access to comprehensive materials such as guidelines, checklists, and templates to streamline compliance processes.</li>
                <li>Developing tools and resources that simplify adherence to complex regulatory frameworks.</li>
              </ul>
            </li>

            <li><b>Practical Application:</b>
              <ul>
                <li>Offering hands-on support to implement compliance measures within business operations.</li>
                <li>Guiding clients through case studies and simulations to reinforce learning and application.</li>
              </ul>
            </li>

            <li><b>Customized Training Programs:</b>
              <ul>
                <li>Tailoring training sessions to reflect the unique cultural, economic, and operational context of tribal organizations.</li>
                <li>Incorporating examples and case scenarios relevant to the industries and challenges faced by clients.</li>
              </ul>
            </li>

            <li><b>Ongoing Support:</b>
              <ul>
                <li>Establishing channels for ongoing consultation, troubleshooting, and updates on regulatory changes.</li>
                <li>Providing post-training follow-up to address specific concerns or clarify compliance requirements.</li>
              </ul>
            </li>
          </ol>

          <p><b>Impact on Tribal Enterprises:</b></p>
          <p>By prioritizing education and resources, Regulatory Training & Support empowers clients to build a robust culture of compliance, enhancing operational efficiency and ensuring sustained growth. The service not only protects businesses from legal risks but also strengthens their reputation and trust among partners and customers.</p>
        `
    },
]

export const ComprehensiveData = [
    {
      section: "Board Governance & Training",
      items: [
        "Membership management",
        "Comprehensive board training programs"
      ]
    },
    {
      section: "Lending Program & Licensing Development",
      items: [
        "Implementation of new lending programs",
        "Establishment of a structured licensing process"
      ]
    },
    {
      section: "Audit & Compliance Oversight",
      items: [
        "Reviewing audit findings and regulatory assessments",
        "Conducting audits or assisting in auditor selection and oversight"
      ]
    },
    {
      section: "Comprehensive Compliance Framework",
      items: [
        "Development of robust compliance programs",
        "Establishing a structured complaint-handling process",
        "Monitoring compliance among licensees",
        "Creating a streamlined dispute resolution process"
      ]
    }
  ];
  

export const ComprehensiveData2 = [
    {
        point: "Establish a complaint handling process"
    },
    {
        point: "Establish compliance monitoring of the licensees"
    },
    {
        point: "Establish a dispute resolution process"
    },
];

export const BusinessSupportData = [
    {
        list: "Board membership"
    },
    {
        list: "Vendor selection"
    },
    {
        list: "Ensuring all policies and procedures are in place "
    },
    {
        list: "Ensuring all consumer documents are in place"
    },
    {
        list: "Reviewing product testing process"
    },
    {
        list: "Ensuring all sign-offs are obtained"
    },
    {
        list: `Reviewing program results from a compliance
        perspective`
    },
    {
        list: `Making recommendations to enhance program
performance`
    },
];

export const TribalSupportCardData = [
    {
        count: "1",
        text: `Tribal lending and ecommerce policies and procedures`
    },
    {
        count: "2",
        text: `Lending Program implementation`
    },
    {
        count: "3",
        text: `Regulatory,Compliace, or Audit Committee Member`
    },
    {
        count: "4",
        text: `Lending & E-commerce Compliance Oversight & Training`
    },
    {
        count: "5",
        text: `Lender, Vendor and Individual Licensing`
    },
    {
        count: "6",
        text: `Regulatory Training`
    },
];

export const TrainingSectionData = [
    {
        point: `On-line Training and Testing designed to Meet the Requirements of Regulators`
    },
    {
        point: `Training Meets the Needs of the Full Lending Organization`
    },
    {
        point: `Training is Comprehensive and Covers all Regulatory Training`
    },
    {
        point: `Courses are Updated as Regulations Change`
    },
    {
        point: `Improved Knowledge Retention`
    },
    {
        point: `Consistency in the Quality of Training`
    },
    {
        point: `Integrated Training Topics to Address Your Core Business Strategy`
    },
    {
        point: `Mitigate the Risks of Knowledge Deficiencies`
    },
];

export const FooterIcons = [
    {
        icon: <FaFacebookF/>
    },
    {
        icon: <FaInstagram/>
    },
    {
        icon: <FaLinkedinIn/>
    },
];

export const Services = {
    title: "Our Services",
    links: [
        {
            link: 'Executive Experience'
        },
        {
            link: 'Policy and Process'
        },
        {
            link: 'Accounting'
        },
        {
            link: 'Strategic Consulting'
        },
        {
            link: 'Management Consulting'
        },
    ]
};

export const QuickLinks = {
    title: "QuickLinks",
    links: [
        {
            link: 'Home',
            path: "home",
        },
        {
            link: 'Services',
            path: "services",
        },
        {
            link: 'About us',
            path: "about",
        },
        {
            link: 'Contact us',
            path: 'contact',
        },
    ]
};

export const InfoData = [
    {
        icon: <FaPhoneAlt/>,
        title: "Any Questions?",
        content: "(877) 212-6380 X 1002",
    },
    {
        icon: <TfiEmail/>,
        title: "Write Email?",
        content: "info@tribalreg.com"
    },
    {
        icon: <FaLocationDot/>,
        title: "Location",
        content: `2700 S Woodlands Village Blvd Ste 300-329 Flagstaff, AZ 86001`,
    },
];

